export default __webpack_public_path__ + "static/media/UniversLTStd-UltraCn.2c26d182.otf";